import { useState, useEffect } from 'react';

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="px-8 md:px-16 lg:px-24 py-6">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${scrolled ? 'bg-orange-500' : 'bg-white/20 backdrop-blur-sm'}`}>
              <i className={`ri-home-smile-2-line text-2xl ${scrolled ? 'text-white' : 'text-white'}`}></i>
            </div>
            <span className={`text-2xl font-bold whitespace-nowrap ${scrolled ? 'text-gray-900' : 'text-white'}`} style={{ fontFamily: 'Inter, sans-serif' }}>
              ReloExpert
            </span>
          </div>

          {/* Navigation Links */}
          <div className="hidden lg:flex items-center gap-10">
            <a href="#services" className={`text-base font-medium transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'}`}>
              Services
            </a>
            <a href="#locations" className={`text-base font-medium transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'}`}>
              Locations
            </a>
            <a href="#corporate" className={`text-base font-medium transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'}`}>
              Corporate Solutions
            </a>
            <a href="#resources" className={`text-base font-medium transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'}`}>
              Resources
            </a>
            <a href="#about" className={`text-base font-medium transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'}`}>
              About Us
            </a>
          </div>

          {/* CTA Button */}
          <button className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 rounded-full text-base font-semibold transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap">
            Schedule Consultation
            <i className="ri-arrow-right-line text-lg"></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
